module.exports = __webpack_public_path__ + "img/payment-slip.fd65b3d6.png";